<template>
  <ServiceInfo :data="data" />
</template>

<script>
import ServiceInfo from "../../components/serviceInfo/ServiceInfo.vue";
import { preparationInfo } from "../../textual/info";
export default {
  components: {
    ServiceInfo,
  },
  computed: {
    data() {
      return preparationInfo;
    },
  },
};
</script>
